import React, { useState } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles'
import { Box, Button, IconButton, Paper, CircularProgress, Typography, TextField } from '@material-ui/core'
import { useTranslate, useDataProvider, Loading, usePermissions } from 'react-admin';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import colors from '../CustomizedUIs/Colors'
import { Add } from '@material-ui/icons'
import icDelete from '../assets/icons/primary-blue-bin.png'

import Search from '../search'
import icArrowUp from '../assets/icons/white-arrow-up.png';
import icArrowDown from '../assets/icons/white-arrow-down.png';
import {
    usePopupState,
    bindToggle,
} from 'material-ui-popup-state/hooks'
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow'
import Snackbar from '../common/snackbar';
import TextButton from '../CustomizedUIs/TextButton';

const useStyles = makeStyles(theme => ({

    tableSortLabel: {
        color: 'theme.palette.common.white',
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },
    },
    paper: {
        padding: '16px 16px',
        width: 300
    }, Title: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 2.4,
        letterSpacing: '0.15px',
        color: '#4f5064',
    },
    textbtnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
  
    btnSave: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '12.5px',
        letterSpacing: '0.4px',
        color: '#ffffff',
    },
    TitleName: {
        fontFamily: ' UniviaPro',
        fontSize: ' 13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#ffffff',
    },
    borderItem: {
        borderRadius: '4px',
        boxShadow: '0 3px 6px 0 rgba(27, 102, 157, 0.04)',
        backgroundColor: '#ffffff',
    },
    textValue: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#237fc2',
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
    }, input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }, fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#88898c',
    }, underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    underlineError: {
        '&::after': {
            borderBottom: '2px solid' + '#eb5a4d'
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    textEdit: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        ctextEdolor: '#ffffff',
        padding: '5px 8px 5px 8px'
    },
    icons: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 7,
        cursor: 'pointer'
    },
    icon: {
        width: 9,
        height: 9
    },
    borderDelete: {
        borderRadius: '12px',
        backgroundColor: '#e5f1f8',
    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    }
}));

const PopupEdit = ({ popupState, value, onClose, onChangeText, onCreate, loading, error }) => {
    const translate = useTranslate();
    const classes = useStyles()
    return (
        <Paper className={classes.paper}>
            <Typography className={classes.TitleCreate} style={{ marginBottom: 8 }}>{translate(`pos.media.createCategory`)}</Typography>
            <TextField
                error={error.status && error.message}
                helperText={error.message}
                onChange={onChangeText}
                onBlur={onChangeText}
                value={value}
                placeholder={translate(`pos.media.categoryName`)}
                FormHelperTextProps={{
                    className: classes.textError
                }}
                InputLabelProps={{
                    // className: classes.textLabel,
                    classes: {
                        root: classes.textLabel,
                        error: classes.textLableError
                    }
                }}
                InputProps={{
                    className: classes.input,
                    classes: {
                        underline: error.message ? classes.underlineError : (value !== '' ? classes.underline : classes.underlineNotValue),
                        focused: classes.focuses
                    }
                }}
                fullWidth />
            <Box mt={1} display='flex' justifyContent='flex-end' width='100%'>
                <Button onClick={onClose} color='primary'>{translate(`pos.common.cancel`)}</Button>
                <Button disabled={error.status || loading} onClick={onCreate} style={{ marginLeft: 8, padding: "5px 8px 5px 8px" }} variant='contained' color='primary'>
                    {loading ? (
                        <CircularProgress
                            size={15}
                            thickness={2}
                            color='inherit'
                        />
                    ) :
                        <Typography className={classes.btnSave}>{translate(`pos.common.save`)}</Typography>
                    }
                </Button>
            </Box>
        </Paper >
    )
}

const Categorys = () => {
    const dataProvider = useDataProvider()
    const classes = useStyles()
    const translate = useTranslate()
    const [data, setData] = useState([])
    const [dataFilter, setDataFilter] = useState([])
    const { permissions, loaded } = usePermissions();
    const [stateUpdate, setStateUpdate] = useState('')
    const [error, setError] = useState({ status: true, message: '' })
    const [dataCreate, setDataCreate] = useState('')
    const popupState = usePopupState({ variant: 'popper', popupId: 'createDialog' })
    const [loadingCreate, setLoadingCreate] = useState(false)
    const [filter, setFilter] = useState('')
    const [openConfirmDialog, setOpenConfirmDialog] = useState({
        status: false,
        index: -1
    })
    const [loading, setLoading] = useState(false)
    const theme = useTheme()
    const [click, SetClick] = useState(false)
    const [showSnackbar, setShowSnackbar] = useState({
        name: '',
        status: false
    })
    const [showSnackbarEdit, setShowSnackbarEdit] = useState({
        name: '',
        status: false
    })

    const getList = () => {
        setLoading(true)
        dataProvider('GET_LIST', "channels/findcategory", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setData(data);
                setDataFilter(data)
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            })
    }

    React.useEffect(() => {
        getList()
    }, [])

    const submitFilter = () => {
        setDataFilter(data.filter(item => item.name.toUpperCase().includes(filter.toUpperCase())))
    }

    const onClosePopupCreate = () => {
        popupState.close()
        setDataCreate('')
        setError({ status: true, message: '' })
    }

    const onCancel = (index) => {
        let temps = data.slice()
        temps[index].edit = false
        delete temps[index].editName
        setData(temps)
    }

    const onChangeTextCreate = (event) => {
        setDataCreate(event.target.value)
        if (event.target.value.length === 0)
            setError({
                status: true,
                message: 'required'
            })
        else {
            setError({
                status: false,
                message: ''
            })
        }
    }

    const onCreate = () => {
        setLoadingCreate(true)
        dataProvider('CREATE', "channels/createcategory", {
            data: {
                name: dataCreate
            }
        })
            .then((response) => {
                getList()
                setLoadingCreate(false)
                popupState.close()
                setShowSnackbar({
                    name: response.data.name,
                    status: true
                })
                setTimeout(() => {
                    setShowSnackbar({
                        name: '',
                        status: false
                    })
                }, 6000);

            })
            .catch(error => {
                console.log(error)
                if (error.message === 'exist')
                    setError({
                        status: true,
                        message: 'Name exist'
                    })
                setLoadingCreate(false)
            })
    }

    const handleOnDelete = () => {
        if (openConfirmDialog.index > -1) {
            dataProvider('DELETE', "channels/deletecategory", {
                id: data[openConfirmDialog.index].id
            })
                .then(() => {
                    getList()
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
                .catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
        }

    }

    const handleOutFocus = (value, index) => {
        if (value.length > 0) {
            var temps = data.slice()
            if (data[index].name === data[index].editName) {
                temps[index].edit = false
                setData(temps)
            }
            else {

                temps[index].loading = true
                setData(temps)
                temps = data.slice()
                dataProvider('UPDATE', "channels/editcategory", {
                    id: data[index].id,
                    data: {
                        name: temps[index].editName
                    }
                })
                    .then(() => {
                        temps[index].name = temps[index].editName
                        delete temps[index].editName
                        temps[index].edit = false
                        delete temps[index].loading
                        setData(temps)
                        setShowSnackbarEdit({
                            name: temps[index].name,
                            status: true
                        })
                        setTimeout(() => {
                            setShowSnackbarEdit({
                                name: '',
                                status: false
                            })
                        }, 6000);

                    })
                    .catch(error => {
                        delete temps[index].loading
                        if (error.message === 'exist')
                            temps[index].error = 'name exist'
                        else
                            temps[index].error = 'rename failed'
                        setData(temps)
                    })
            }

        }
    }

    const onClick = () => {
        setDataFilter(dataFilter.reverse())
        SetClick(!click)
    }

    const handleClickReName = (name, index) => {
        let temps = data.slice()
        temps[index].edit = true
        temps[index].editName = name
        setData(temps)
    }

    const onChangeText = (event, index) => {
        let temps = data.slice()
        if (event.target.value.length === 0)
            temps[index].error = 'required'
        else
            delete temps[index].error
        temps[index].editName = event.target.value
        setData(temps)
    }

    React.useEffect(() => {
        !popupState.isOpen && setDataCreate('')
    }, [popupState])

    if (loading || !loaded) return <Loading />
    return (
        <Box width='100%' display='flex' justifyContent='center'>
            <Box width='60%' mt={8}>
                <Box width='100%' display='flex' justifyContent='flex-end'>
                    <Snackbar
                        show={showSnackbar.status}
                        boldText={showSnackbar.name}
                        message={translate(`pos.categories.createFolder.success`)}
                        onClose={() => setShowSnackbar({
                            name: '',
                            status: false
                        })}
                    />
                    <Snackbar
                        show={showSnackbarEdit.status}
                        boldText={showSnackbarEdit.name}
                        message={translate(`pos.categories.editFolder.success`)}
                        onClose={() => setShowSnackbarEdit({
                            name: '',
                            status: false
                        })}
                    />

                </Box>
                <Box width='100%' display='flex' alignItems='center'>
                    <Box flexGrow={1} display="flex" flexDirection="row" alignItems="center">
                        <Typography className={classes.Title} >{translate(`pos.categories.categoryChannel`)}</Typography>
                        {
                            dataFilter.length > 0 ? <Typography className={classes.subText}>({dataFilter.length})</Typography>
                                : <Typography className={classes.subText}>(0)</Typography>
                        }

                    </Box>
                    <Search
                        placeholder={'Category'}
                        onChangeText={setFilter}
                        getList={submitFilter}
                    />
                    {
                        permissions.functionAction.find(value => value.function === 'Channels and programs' && value.isUpdate) &&
                        <Box ml={4}>
                            <Button {...bindToggle(popupState)} variant='contained' color='primary' disabled={data.filter(e => e.edit).length > 0}>

                                <Typography className={classes.textbtnCreate}>{translate(`pos.media.createNewCategory`)}</Typography>
                                < Add />
                            </Button>
                            <CustomPopoverArrow
                                zIndex={2}
                                popupState={popupState}
                                placement='bottom'
                            >
                                <PopupEdit
                                    onClose={onClosePopupCreate}
                                    error={error}
                                    onCreate={onCreate}
                                    value={dataCreate}
                                    onChangeText={onChangeTextCreate}
                                    loading={loadingCreate}
                                    popupState={popupState} />

                            </CustomPopoverArrow>
                        </Box>
                    }

                </Box>
                <Box>
                    <Box display='flex' px={3} py={2} mt={1} bgcolor={theme.palette.primary.main}>
                        <Box flexGrow={1} display='flex' alignItems='center'>
                            <Typography
                                style={{ cursor: 'pointer', fontSize: 13 }}
                                className={classes.TitleName}>
                                {translate(`pos.dashboard.name`)}
                            </Typography>
                            <div className={classes.icons}>
                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} onClick={onClick} style={{ opacity: click === true ? 0 : 1 }} />
                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click === false ? 0 : 1 }} onClick={onClick} />
                            </div>
                        </Box>
                    </Box>
                    <Box height='60vh' style={{ overflow: 'auto' }}>
                        {
                            dataFilter.map((item, index) => (
                                <Box key={'channel' + index} display='flex' px={3} py={2} mt={1} className={classes.borderItem}>
                                    <Box flexGrow={1} display='flex' alignItems='center'>
                                        {
                                            item.edit ?
                                                (
                                                    <Box display='flex' alignItems='center'>
                                                        <TextField
                                                            disabled={item.loading}
                                                            error={item.error !== undefined}
                                                            helperText={item.error}
                                                            onKeyDown={(event) => {
                                                                event.key === 'Enter' && (handleOutFocus(item.editName, index))
                                                            }}
                                                            value={item.editName}
                                                            onChange={(event) => onChangeText(event, index)}
                                                            autoFocus={true} id="standard-basic"
                                                            FormHelperTextProps={{
                                                                className: classes.textError
                                                            }}
                                                            InputLabelProps={{
                                                                // className: classes.textLabel,
                                                                classes: {
                                                                    root: classes.textLabel,
                                                                    error: classes.textLableError
                                                                }
                                                            }}
                                                            InputProps={{
                                                                className: classes.input,
                                                                classes: {
                                                                    underline: item.error ? classes.underlineError : (item.editName !== '' ? classes.underline : classes.underlineNotValue),
                                                                    focused: classes.focuses
                                                                }
                                                            }} />
                                                        <Box ml={2} display='flex' height={25}>
                                                            <Button
                                                                disabled={item.loading}
                                                                size='small'
                                                                style={{ height: 25 }}
                                                                color='primary'
                                                                onClick={() => handleOutFocus(item.editName, index)}
                                                                variant='contained'>
                                                                {item.loading ? (
                                                                    <CircularProgress
                                                                        size={15}
                                                                        thickness={2}
                                                                        color='inherit'
                                                                    />
                                                                ) :
                                                                    <Typography className={classes.btnSave}>{translate(`pos.common.save`)}</Typography>
                                                                }
                                                            </Button>
                                                            <Box ml={1} display='flex' alignItems='flex-end'>
                                                                <TextButton onClick={() => onCancel(index)} />
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                )
                                                :
                                                <Typography
                                                    color='primary'
                                                    style={{ cursor: 'pointer', fontSize: 13 }}
                                                    variant='body1'>
                                                    <b>{item.name}</b>
                                                </Typography>

                                        }

                                    </Box>
                                    {
                                        permissions.functionAction.find(value => value.function === 'Channels and programs' && value.isUpdate) &&
                                        <Box display='flex' justifyContent='flex-end' alignItems='center'>

                                            <Box mr={1}>
                                                <Button size='small' disabled={item.edit} onClick={() => handleClickReName(item.name, index)} variant='contained' color='primary'>
                                                    <Typography className={classes.textEdit} style={{ padding: '8px' }} >{translate(`pos.common.edit`)}</Typography>
                                                </Button>
                                            </Box>
                                            <IconButton
                                                style={{ marginLeft: '1em', padding: '10px' }}
                                                className={classes.borderDelete}
                                                size='small'
                                                onClick={() => {
                                                    setOpenConfirmDialog({
                                                        status: true,
                                                        index: index
                                                    })
                                                }}
                                            >
                                                <img src={icDelete} width={15} height={15} />
                                            </IconButton>

                                        </Box>
                                    }

                                </Box>
                            ))
                        }
                    </Box>


                </Box>
            </Box>
            <ConfirmDialog
                open={openConfirmDialog.status}
                handleClose={() => { setOpenConfirmDialog({ status: false, index: -1 }) }}
                handleConfirm={handleOnDelete}
                ContentText={translate('pos.user.contentDelete')}
                Tittle={translate('pos.categories.deleteCategoryChannel')} />
        </Box>
    )
}
export default Categorys